import { BiFlag } from 'react-icons/bi'
import { useDisclosure } from '@chakra-ui/react'
import { Button } from '@opengovsg/design-system-react'

import { ReportIssueModal } from './ReportIssueModal'

export interface ReportIssueButtonProps {
  eventId: string
}

/**
 * Floating button pinned to the public booking page that lets an
 * attendee report an issue with the event to the event admin.
 */
export const ReportIssueButton = ({ eventId }: ReportIssueButtonProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <>
      <Button
        position="fixed"
        bottom={{ base: '1rem', md: '1.5rem' }}
        right={{ base: '1rem', md: '1.5rem' }}
        zIndex="docked"
        variant="outline"
        bgColor="white"
        size="xs"
        borderRadius="full"
        leftIcon={<BiFlag />}
        onClick={onOpen}
      >
        Report an issue
      </Button>
      <ReportIssueModal isOpen={isOpen} onClose={onClose} eventId={eventId} />
    </>
  )
}
